module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-ThinItalic-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-ThinItalic-webfont.ttf
// module id = 1626
// module chunks = 0